import { eTipoPermissao } from '@/enums/ePermissoes';
import { eModeloNotasFaltas } from '@/models/academico/relatorios/notasfaltas/notas-faltas.model';

/*
 * EMISSÃO DE NOTAS E FALTAS — migração de `EmitirNotasFaltas.aspx`.
 *
 * Uma ROTA POR MODELO, todas apontando para a mesma tela. São seis itens de menu no legado, cada
 * um com a sua permissão, e é assim que a rede libera um sem o outro. O modelo vai em
 * `meta.modelo` e não em query string: a query string não atravessa o proxy que abre a tela nova
 * a partir do menu do legado (`/proxylegado/<name>`), então cada variante precisa de rota própria.
 *
 * As permissões são as NOVAS (300802909-914) e nunca as dos itens legados (300802901-906) —
 * ver CLAUDE.md, "Permissão de tela nova". O primeiro modelo é o 914, e não o 909, porque 907 e
 * 908 já eram de Notas Parciais e Totais. A sequência fora de ordem é a que está cadastrada na
 * Seg_Menu: renumerar aqui desligaria a permissão de quem já a recebeu.
 */
const tela = () => import('@/views/academico/relatorios/notasfaltas/Index.vue');

export default [
  {
    description: 'Notas e Frequências Pendentes',
    path: '/academico/relatorios/notasfrequenciaspendentes',
    name: 'notas-frequencias-pendentes',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.NOTASEFREQUENCIASPENDENTESNOVO_MENU_300802914],
      modelo: eModeloNotasFaltas.NotasFrequenciasPendentes,
    },
    goesToMenu: true,
  },
  {
    description: 'Notas e Faltas do Bimestre',
    path: '/academico/relatorios/notasfaltasbimestre',
    name: 'notas-faltas-bimestre',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.NOTASEFALTASDOBIMESTRENOVO_MENU_300802909],
      modelo: eModeloNotasFaltas.NotasFaltasDaEtapa,
    },
    goesToMenu: true,
  },
  {
    description: 'Aproveitamento Acumulado',
    path: '/academico/relatorios/aproveitamentoacumulado',
    name: 'aproveitamento-acumulado',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.APROVEITAMENTOACUMULADONOVO_MENU_300802910],
      modelo: eModeloNotasFaltas.AproveitamentoAcumulado,
    },
    goesToMenu: true,
  },
  {
    description: 'Frequências Conflitantes',
    path: '/academico/relatorios/frequenciasconflitantes',
    name: 'frequencias-conflitantes',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.FREQUENCIASCONFLITANTESNOVO_MENU_300802911],
      modelo: eModeloNotasFaltas.FrequenciasConflitantes,
    },
    goesToMenu: true,
  },
  {
    description: 'Notas Divergentes',
    path: '/academico/relatorios/notasdivergentes',
    name: 'notas-divergentes',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.NOTASDIVERGENTESNOVO_MENU_300802912],
      modelo: eModeloNotasFaltas.NotasDivergentes,
    },
    goesToMenu: true,
  },
  {
    description: 'Abaixo da Média',
    path: '/academico/relatorios/abaixodamedia',
    name: 'abaixo-da-media',
    component: tela,
    meta: {
      permissions: [eTipoPermissao.ABAIXODAMEDIANOVO_MENU_300802913],
      modelo: eModeloNotasFaltas.AbaixoDaMedia,
    },
    goesToMenu: true,
  },
];
